import type { GridMouseEventArgs } from '@glideapps/glide-data-grid';

import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';

interface Props {
  cell: GridMouseEventArgs | null;
  onClick: (index: number) => void;
}

export const RowInsert = ({ cell, onClick }: Props) => {
  if (cell === null || cell.kind !== 'cell') return null;

  const { bounds, location } = cell;

  const [_, rowIndex] = location;

  return (
    <div className="absolute left-[25px]" style={{ top: bounds.y - 8 }}>
      <div className="absolute h-[1px] w-screen top-x1 left-[-25px] bg-p-grey-100 bg-opacity-20" />
      <button
        className="relative w-x2 h-x2 rounded-x1_5 bg-brand-03 z-10 pt-x0_25"
        onClick={() => onClick(rowIndex)}
      >
        <PlusSolid
          width={12}
          height={12}
          fill="white"
          aria-label="Insert row"
        />
      </button>
    </div>
  );
};
